interface CompanyInterface {
  display_name: string;
  short_name: string;
}

class CompanyService {
  private companies: Array<CompanyInterface> = [];
  private index: number = 0; // @TODO: maybe user can switch between companies

  constructor() {
    try {
      const companiesJson = localStorage.getItem('companies');
      if (!companiesJson) {
        return;
      }

      this.companies = JSON.parse(companiesJson);
      this.index = Number(localStorage.getItem('company_index') || '');
    } catch (e) {}
  }

  setCompanies(companies: Array<CompanyInterface>) {
    this.index = 0;
    this.companies = companies;

    localStorage.setItem('companies', JSON.stringify(companies));
  }

  getCompanies() {
    return this.companies;
  }

  clear() {
    this.companies = [];
    this.index = 0;

    localStorage.removeItem('company_index');
    localStorage.removeItem('companies');
  }

  getCurrent(): Nullable<CompanyInterface> {
    if (this.companies.length == 0) {
      return null;
    }

    return this.companies[this.index];
  }

  setIndex(index: number) {
    this.index = index;
    localStorage.setItem('company_index', index.toString());
  }

  getShortName(): string {
    return this.getCurrent()?.short_name || '';
  }

  getDisplayName(): string {
    return this.getCurrent()?.display_name || '';
  }
}

export default new CompanyService();
